__turbopack_context__.v({
  "banner": "Bc_FGW_banner",
  "placeholder": "Bc_FGW_placeholder",
});
